import React, { PropsWithChildren } from 'react';
import './MobileGate.css';

interface MobileGateProps {
  isOpen: boolean;
  onClose: () => void;
  onContinue?: () => void;
  title?: string;
  message?: string;
  showCancelButton?: boolean;
  showContinueButton?: boolean;
}

const MobileGate: React.FC<PropsWithChildren<MobileGateProps>> = ({
  isOpen,
  onClose,
  onContinue,
  title = 'Best viewed on desktop',
  message = 'This application is optimized for larger screens. Please switch to a desktop or laptop for the best experience.',
  showCancelButton = true,
  showContinueButton = true,
  children,
}) => {
  if (!isOpen) {
    return null;
  }

  return (
    <div className="mobile-gate-overlay">
      <div className="mobile-gate-panel">
        <h2>{title}</h2>
        <p>{message}</p>
        {children || (
          <div style={{ display: 'flex', gap: '12px', justifyContent: 'center', flexWrap: 'wrap-reverse' }}>
            {showCancelButton && (
              <button
                className="mobile-gate-btn"
                style={{ backgroundColor: '#666' }}
                onClick={onClose}
              >
                Cancel
              </button>
            )}
            {showContinueButton && (
              <button
                className="mobile-gate-btn"
                onClick={onContinue || onClose}
              >
                Continue anyway
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default MobileGate;
